import { getSubSteps } from '#models/general/steps';

import { getChargingFields } from './charging';
import { getDipsFields } from './dips';
import { getSpiritIdsFields } from './spiritIds';
import { getSpiritSetUpFields } from './spiritSetUp';
import { getDipISRFields } from './dipISR';
import { getStillRunFields } from './stillRun';

export const SPIRIT_SUBSTEP_TARGET = 'AdelphiSpiritStepModal';

export const SPIRIT_SUBSTEPS_IDS = {
  SPIRIT_SCREEN_SET_UP: 'spiritScreenSetUpAdelphi',
  SPIRIT_IDS: 'spiritIdsAdelphi',
  CHARGING: 'chargingAdelphi',
  STILL_RUN: 'stillRunAdelphi',
  DIP_ISR: 'dipISRAdelphi',
  DIPS: 'dipsAdelphi'
};

const SPIRIT_NEXT_SUBSTEPS = {
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP]: SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS,
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS]: SPIRIT_SUBSTEPS_IDS.CHARGING,
  [SPIRIT_SUBSTEPS_IDS.CHARGING]: SPIRIT_SUBSTEPS_IDS.STILL_RUN,
  [SPIRIT_SUBSTEPS_IDS.STILL_RUN]: SPIRIT_SUBSTEPS_IDS.DIP_ISR,
  [SPIRIT_SUBSTEPS_IDS.DIP_ISR]: SPIRIT_SUBSTEPS_IDS.DIPS
};

const SPIRIT_PREVIOUS_SUBSTEPS = {
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS]: SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP,
  [SPIRIT_SUBSTEPS_IDS.CHARGING]: SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS,
  [SPIRIT_SUBSTEPS_IDS.STILL_RUN]: SPIRIT_SUBSTEPS_IDS.CHARGING,
  [SPIRIT_SUBSTEPS_IDS.DIP_ISR]: SPIRIT_SUBSTEPS_IDS.STILL_RUN,
  [SPIRIT_SUBSTEPS_IDS.DIPS]: SPIRIT_SUBSTEPS_IDS.DIP_ISR
};

export const SPIRIT_SUBSTEPS = getSubSteps(
  SPIRIT_SUBSTEP_TARGET,
  SPIRIT_SUBSTEPS_IDS,
  SPIRIT_NEXT_SUBSTEPS,
  SPIRIT_PREVIOUS_SUBSTEPS
);

export const SPIRIT_COMPLETE_FIELDS = {
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP]: getSpiritSetUpFields,
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS]: getSpiritIdsFields,
  [SPIRIT_SUBSTEPS_IDS.CHARGING]: getChargingFields,
  [SPIRIT_SUBSTEPS_IDS.STILL_RUN]: getStillRunFields,
  [SPIRIT_SUBSTEPS_IDS.DIP_ISR]: getDipISRFields,
  [SPIRIT_SUBSTEPS_IDS.DIPS]: getDipsFields
};

export const SPIRIT_SUBSTEPS_ADDITION_PROPS = {
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP]: {
    oneColumnForm: true
  },
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS]: {
    oneColumnForm: true
  },
  [SPIRIT_SUBSTEPS_IDS.CHARGING]: {
    oneColumnForm: true
  },
  [SPIRIT_SUBSTEPS_IDS.DIP_ISR]: {
    oneColumnForm: true
  },
  [SPIRIT_SUBSTEPS_IDS.DIPS]: {
    oneColumnForm: true
  }
};

export const ADELPHI_SPIRIT_SUBSTEPS_INFO = {
  target: SPIRIT_SUBSTEP_TARGET,
  substeps: SPIRIT_SUBSTEPS,
  fields: SPIRIT_COMPLETE_FIELDS,
  additionalProps: SPIRIT_SUBSTEPS_ADDITION_PROPS
};

export const SPIRIT_SET_UP_FIELDS = {
  SPIRIT_RUN_DATE_AND_TIME: 'spiritRunDateAndTime',
  PERIOD_ID: 'periodId',
  MASH_ID: 'mashingId',
  WASH_ID: 'washId',
  LWFR_VOLUME: 'LWFRVolume'
};

export const SPIRIT_IDS_FIELDS = {
  SPIRIT_ID: 'spiritId'
};

export const SPIRIT_CHARGING_FIELDS = {
  DATE_AND_TIME_CHARGED: 'dateAndTimeCharged',
  VALVES_CLOSED: 'spiritChargedValvesClosed'
};

export const STILL_RUN_FIELDS = {
  TIME_ON_SPIRIT: 'timeOnSpirit',
  TIME_OFF_SPIRIT: 'timeOffSpirit',
  TIME_STILL_OFF: 'timeStillOff',
  HYDROMETER_TIME_ON_SPIRIT: 'hydrometerTimeOnSpirit',
  HYDROMETER_TIME_OFF_SPIRIT: 'hydrometerTimeOffSpirit',
  HYDROMETER_TIME_STILL_OFF: 'hydrometerTimeStillOff',
  TEMPERATURE_TIME_ON_SPIRIT: 'temperatureTimeOnSpirit',
  TEMPERATURE_TIME_OFF_SPIRIT: 'temperatureTimeOffSpirit',
  TEMPERATURE_TIME_STILL_OFF: 'temperatureTimeStillOff',
  FORESHOTS_START_TIME: 'foreshotsStartTime'
};

export const DIPS_ISR_FIELDS = {
  DIP_ISR_HEIGHT: 'dipISRHeight',
  DIP_ISR_VOLUME: 'dipISRVolume',
  ISR_TRANSFERRED: 'ISRTransferred',
  ISR_VOLUME_TRANSFERRED: 'ISRVolumeTransferred',
  ISR_OPERATOR: 'ISROperator'
};

export const SPIRIT_DIPS_FIELDS = {
  LWFR_DIP_HEIGHT: 'LWFRDipHeight',
  LWFR_DIP_VOLUME: 'LWFRDipVolume'
};
